module.exports = "https://static.im-cdn.com/mjc/storefront/Simplar/static/media/noProducts.052281fc.svg";